import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import Image from "../../components/image";
import { asset } from "../../helpers/dom.helper";
import { ContentWrapper } from "../../layouts";
import { Media, MediaContextProvider } from "../../media";
import {isMobile} from 'react-device-detect';
import Guarantee from "../../pages/Home/guaranteeHome";
import RegisterHome from "../../pages/Home/registerHome";
import Blog from "../../components/blogFooter/blogFooter";
import styles from '../seminar/seminar.module.scss';
import '../seminar/style.scss';

export default function FreshketLanding() {

     const { t } = useTranslation(['translation', 'privilege'])
  
    return (
      <>
        <Helmet>
          <title>โปรแกรมบัญชีและบริหารงานสำหรับ นิติบุคคลอาคารชุด นิติบุคคลหมู่บ้าน อาคารสำนักงาน | Silverman Application</title>
          <meta name="description" content={t("debt:metaDescription")} />
          <meta name="keywords" content={t("debt:metaKeyWord")} />
          <link rel="canonical" href="https://silverman.app/seminar" />  
        </Helmet>
        <div className={styles.seminarWrapper+ " "+"seminar-wrapper"}>
        <ContentWrapper className="pt-5 pb-5">
            <div className="text-center">
            <a href="https://freshket.co/registration?utm_campaign=silverman" target="_blank" rel="noopener noreferrer"> 
                <Image  
                    src={asset('/images/freshket/Silverman-partnership-landing-page.jpg')}
                    alt="freshket" className='img-fluid'/>
            </a>
            </div>
            <div className="pt-5 pb-5 text-center"> 
                <a href="https://freshket.co/registration?utm_campaign=silverman" target="_blank" rel="noopener noreferrer"> 
                    <button className="btn btn-register-freshket">
                        <span dangerouslySetInnerHTML={{ __html: t("privilege:Register Now") }} />
                    </button>
                </a>
            </div>
        </ContentWrapper>
        </div>
      </>
    )
  
  }